<style>
  img {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
}
</style>
<div>
  <img src="assets/images/simmons_logo.svg" alt="sams" class="img-fluid" style="width: 80%;height: 80%;">  
</div>